import { Directive, forwardRef, Input, inject, type OnChanges } from "@angular/core";
import { type AbstractControl, NG_VALIDATORS, type ValidationErrors, type Validator } from "@angular/forms";
import { CurrencyService } from "../currency.service";

@Directive({
  selector: "input[maxOverMinValidator][ngModel]",
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MaxOverMinValidatorDirective), multi: true }],
})
export class MaxOverMinValidatorDirective implements OnChanges, Validator {
  @Input() public maximumAmountRange: string = "";

  private readonly currencyService = inject(CurrencyService);
  private validatorChanged: () => void = () => {};

  public ngOnChanges(): void {
    this.validatorChanged();
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    const minimumAmountResult = this.currencyService.parseValue(control.value ?? "");
    const maximumAmountResult = this.currencyService.parseValue(this.maximumAmountRange);

    if (
      !minimumAmountResult.isValid ||
      !maximumAmountResult.isValid ||
      minimumAmountResult.value == null ||
      maximumAmountResult.value == null ||
      minimumAmountResult.value <= maximumAmountResult.value
    ) {
      return null;
    }

    return { invalidAmountRange: true };
  }

  public registerOnValidatorChange(fn: () => void): void {
    this.validatorChanged = fn;
  }
}
